<p class="mr-medium-b">{{ 'myTrips.table.intro' | finLocalization }}</p>
<div
  aria-live="polite"
  class="nordic-blue-900-text text-icon-primary font-body-1 fill align-center font-body-medium"
  *ngIf="status === Status.LOADING"
>
  <p>{{ 'myTrips.table.loading' | finLocalization }}</p>
  <fcom-loader [loaderType]="LoaderTheme.INLINE_TEXT" />
</div>
<ng-container *ngIf="trips$ | async as trips">
  <fcom-notification
    *ngIf="status === Status.ERROR"
    aria-live="assertive"
    class="mr-small-b"
    [theme]="NotificationTheme.ALERT"
    [layout]="NotificationLayout.BLOCK"
    [iconName]="SvgLibraryIcon.INFO"
    [isClosable]="true"
    [i18n]="{ closeAriaLabel: 'plus.profile.closeNotification' }"
    (closeClick)="status = Status.INITIAL"
  >
    {{ 'myTrips.table.error' | finLocalization }}
  </fcom-notification>
  <ng-container *ngIf="trips.length > 0">
    <table class="fill" [attr.aria-label]="'myTrips.heading' | finLocalization">
      <thead class="font-body-1 font-body-medium">
        <th
          scope="col"
          class="nordic-blue-900-text text-icon-primary bold-type pr-xsmall-b white-bg surface-primary align-left valign-bottom"
        >
          {{ 'myTrips.table.tripDetails' | finLocalization }}
        </th>
        <th
          scope="col"
          class="nordic-blue-900-text text-icon-primary bold-type pr-medium-l pr-xsmall-b white-bg surface-primary align-right valign-bottom"
        >
          {{ 'myTrips.table.bookingRef' | finLocalization }}
        </th>
      </thead>
      <tbody class="border-top">
        <ng-container *ngFor="let trip of trips; let i = index">
          <tr
            #tripRow
            class="border-bottom font-body-1 light-type fade-up font-body-medium"
            *ngIf="i <= lastVisibleIndex"
          >
            <td class="ps-small-y">
              <div class="details flex">
                <span class="date inline-block mr-small-r">{{ trip.scheduledDateTime | finDateFormat: 'DATE' }}</span>
                <span class="bound mr-small-r flex">
                  <span class="truncate overflow-hidden">{{ trip.departure }} - {{ trip.arrival }}</span>
                </span>
                <span
                  class="pax-amount flex"
                  *ngIf="trip.passengerAmount !== undefined && trip.passengerAmount !== null"
                >
                  <span class="truncate overflow-hidden">
                    {{ 'myTrips.table.passenger' | finPluralLocalization: trip.passengerAmount : 'amount' }}
                  </span>
                </span>
              </div>
            </td>
            <td class="pr-medium-l ps-small-y align-right">
              <span class="inline-block">
                <span class="pnr-link flex flex--middle">
                  <span class="pnr mr-small-r align-left" data-hj-suppress>{{ trip.bookingRef }}</span>
                  <span class="flex flex--middle">
                    <a class="nordic-blue-900-text text-icon-primary medium-type" [finLink]="trip.mmbLink">{{
                      'myTrips.table.viewTrip' | finLocalization
                    }}</a>
                  </span>
                </span>
              </span>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div *ngIf="trips.length > visibleRows" class="ms-large-t ms-xxlarge-b flex flex--middle flex--end">
      <fcom-button
        [text]="'myTrips.table.showMoreTrips' | finLocalization"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [icon]="{ name: SvgLibraryIcon.PLUS, position: IconPosition.RIGHT }"
        [type]="ButtonType.BUTTON"
        [disabled]="trips.length <= lastVisibleIndex + 1"
        (clickBtn)="onRevealRows()"
      />
    </div>
  </ng-container>
  <p *ngIf="status === Status.EMPTY" class="mr-small-b block ms-xlarge-t">
    {{ 'myTrips.table.noTrips' | finLocalization }}
  </p>
</ng-container>
